import { BRIGHTCOVE } from '../../../constants/constants';
import PropTypes from 'prop-types';
import React from 'react';

const BrightcoveVideo = ({ accountId, autoplay, playerId, show, bcVideoRefId, title }) => {
  const url = `https://players.brightcove.net/${accountId}/${playerId}/index.html`;
  const query = `?videoId=ref:${bcVideoRefId}${autoplay ? '&muted&autoplay&playsinline' : ''}&applicationId=agentwebsite`;

  return show && (
    <iframe
      title={title}
      src={`${url}${query}`}
      frameBorder={0}
      scrolling="no"
      height="100%"
      allowFullScreen>
    </iframe>
  );
};

BrightcoveVideo.defaultProps = {
  accountId: BRIGHTCOVE.ACCOUNT_ID,
  autoplay: false,
  playerId: `${BRIGHTCOVE.SIR_VIDEO_PLAYER}`,
  show: true,
};

BrightcoveVideo.propTypes = {
  accountId: PropTypes.string,
  autoplay: PropTypes.bool,
  playerId: PropTypes.string,
  show: PropTypes.bool,
  bcVideoRefId: PropTypes.string.isRequired,
};

export default BrightcoveVideo;


// WEBPACK FOOTER //
// ./src/components/shared/brightcove/index.js